import { render, staticRenderFns } from "./BuildingInfo.vue?vue&type=template&id=b8d30aa2&scoped=true&"
import script from "./BuildingInfo.vue?vue&type=script&lang=js&"
export * from "./BuildingInfo.vue?vue&type=script&lang=js&"
import style1 from "./BuildingInfo.vue?vue&type=style&index=1&id=b8d30aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d30aa2",
  null
  
)

export default component.exports